/** What is currently keeping the explore map on a previous slice of the day. */
export interface ExploreMapSelectionSnapshot {
  hasSelection: boolean;
  rangeCount: number;
  rangesCount: number;
  cutCount: number;
  isCut: boolean;
  eventCount: number;
}

export function exploreMapHasSelection(snapshot: ExploreMapSelectionSnapshot): boolean {
  return (
    snapshot.hasSelection ||
    snapshot.rangeCount > 0 ||
    snapshot.rangesCount > 0 ||
    snapshot.cutCount > 0 ||
    snapshot.isCut ||
    snapshot.eventCount > 0
  );
}

/**
 * True when the user changed race or leg after the map had already settled on a filter,
 * and a selection would still hide the race or leg they just chose.
 * An empty previous signature is the first observation after init, not a user change.
 */
export function shouldClearExploreMapSelectionOnFilterChange(
  previousSignature: string,
  nextSignature: string,
  snapshot: ExploreMapSelectionSnapshot,
  liveMode: boolean
): boolean {
  if (liveMode) return false;
  if (!previousSignature) return false;
  if (previousSignature === nextSignature) return false;
  return exploreMapHasSelection(snapshot);
}
